import { render, staticRenderFns } from "./FinancialCard.vue?vue&type=template&id=1d4987be&scoped=true"
import script from "./FinancialCard.vue?vue&type=script&lang=js"
export * from "./FinancialCard.vue?vue&type=script&lang=js"
import style0 from "./FinancialCard.vue?vue&type=style&index=0&id=1d4987be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4987be",
  null
  
)

export default component.exports